import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
  addNewTopic as addNewTopicAction,
  changeEditLang,
  changeEditMode,
  deleteTopic,
  saveCourseOnChange,
  saveLangStep as saveLangStepAction,
  saveTopics,
  selectNewCourseData,
  setEditModeTopicsOff,
  updateTopicsOrder,
} from './createCourseSlice';

const useCreateCourseActions = () => {
  const dispatch = useDispatch();
  const course = useSelector(selectNewCourseData);
  const {selectedLanguages, currentLang, de, en, id} = course;

  const changeEditLangAction = (lang) => {
    dispatch(changeEditLang(lang));
  };

  const saveLangStep = (step) => {
    dispatch(saveLangStepAction(currentLang, step));
  };

  const handleOnChangeCourseAction = (lang, values) => {
    dispatch(saveCourseOnChange({lang, values}));
  };

  const addNewTopic = () => {
    dispatch(addNewTopicAction({lang: currentLang}));
  };

  const handleSaveTopic = (lang, topic, index) => {
    dispatch(saveTopics({lang, topic, index}));
  };

  const handleChangeEditMode = (lang, index, isEditMode) => {
    dispatch(changeEditMode({lang, index, isEditMode}));
  };

  const handleUpdateTopicsOrder = useCallback((language, topics) => {
    dispatch(
      updateTopicsOrder({
        language,
        topics,
      })
    );
  }, []);

  const handleDeleteTopic = (topicId, index, lang) => {
    let topics = [];

    if (!topicId) {
      const topicsFistPart = course[lang || currentLang].topics.slice(0, index);

      const topicsLastPart = course[lang || currentLang].topics.slice(
        index + 1
      );
      topics = [...topicsFistPart, ...topicsLastPart];
    } else {
      topics = course[lang || currentLang].topics.filter(
        (topic) => topic.id !== topicId
      );
    }

    dispatch(deleteTopic({lang: lang || currentLang, topics}));
  };

  const setAllTopicsEditModeOff = useCallback(
    (topics) => {
      const updateTopics = topics
        .map((topic) => ({
          ...topic,
          isEditMode: false,
        }))
        .filter((topic) => topic.id);

      dispatch(
        setEditModeTopicsOff({
          lang: currentLang,
          topics: updateTopics,
        })
      );
    },
    [setEditModeTopicsOff, currentLang]
  );

  return {
    changeEditLangAction,
    handleOnChangeCourseAction,
    addNewTopic,
    saveLangStep,
    handleSaveTopic,
    handleChangeEditMode,
    handleDeleteTopic,
    setAllTopicsEditModeOff,
    handleUpdateTopicsOrder,
    course,
    selectedLanguages,
    currentLang,
    de,
    en,
    id,
  };
};

export default useCreateCourseActions;
